import WorkingHourList from '../components/workinghour/List'
import WorkingHourCreate from '../components/workinghour/Create'
import WorkingHourUpdate from '../components/workinghour/Update'

export default [
  {
    name: 'WorkingHour',
    path: '/working_hours/',
    component: {template: '<router-view></router-view>'},
    redirect: { name: 'WorkingHourList' },
    children: [
      {
        name: 'WorkingHourList',
        path: '',
        component: WorkingHourList,
      },
      {
        name: 'WorkingHourCreate',
        path: 'create',
        component: WorkingHourCreate
      },
      {
        name: 'WorkingHourUpdate',
        path: 'edit/:id',
        component: WorkingHourUpdate
      }
    ]
  },
]
